import { useContext, useEffect, useState } from 'react';
import { ProductVariantType } from '../../common/enums/common';
import { ProductTileCarousel } from '../../components/complex/productCarousel/productTileCarousel';
import { IDeviceInfo, useDevice } from '../../providers/device-provider';
import { colorSchemes } from '../../providers/products/color-scheme-context';
import { ProductConfigContext } from '../../providers/products/product-config-provider';
import { ProductFilterType } from '../../services/helper/pdp/frames/productUtils';
import { IColorVariant, IProductVariant } from '../../services/helper/productInterfaces';
import { getKPRegion } from '../../utils/regionUtils';
import { useSimilarProducts } from './hooks/useSimilarProducts';

export const SimilarProducts = ({
  carouselId,
  title,
  onProductTileClick,
  onVariantChange,
  prodType,
}: {
  carouselId: string;
  title: string;
  onProductTileClick: (productVariant: IProductVariant, productId: string) => void;
  prodType?: ProductFilterType;
  onVariantChange?: (variant: IColorVariant) => void;
}) => {
  const { isMobile } = useDevice();
  const { products } = useSimilarProducts(prodType);
  let colorScheme = useContext(ProductConfigContext);
  const [noOfTilesToDisplay, setNoOfTilesToDisplay] = useState(2);

  useEffect(() => {
    const updateTilesToDisplay = () => {
      if (window.innerWidth < 640) {
        setNoOfTilesToDisplay(2);
      } else {
        setNoOfTilesToDisplay(3);
      }
    };

    updateTilesToDisplay();
    window.addEventListener('resize', updateTilesToDisplay);

    return () => {
      window.removeEventListener('resize', updateTilesToDisplay);
    };
  }, []);

  if (!colorScheme || !Object.keys(colorScheme)?.length) {
    colorScheme = (colorSchemes as any)[getKPRegion()];
  }

  if (!products || !products?.length) return null;
  return (
    <div className="container-none pt-sm pb-md mb-6 bg-neutral-100" data-testid={carouselId}>
      <div className="my-xl justify-center flex-col items-center">
        <h3 className="font-medium text-2xl items-center flex justify-center w-full mb-md text-blue-900" role='heading' aria-label={title}>
          {title}
        </h3>
        <ProductTileCarousel
          data={products}
          noOfTilesToDisplay={noOfTilesToDisplay}
          carouselId={carouselId}
          displayNavControls={!isMobile}
          displayNavIndicators={false}
          className="xl:mx-lg"
          carouselItemClassName=""
          autoSlideInSec={isMobile ? 2 : 0}
          variantType={ProductVariantType.COLOR}
          onProductTileClick={onProductTileClick}
          colorScheme={colorScheme}
          onVariantChange={onVariantChange}
        />
      </div>
    </div>
  );
};
